/*
 * omes-followed-brands.js
 * ---------------------------------------------------------------------------
 * Favoris page (sections/main-wishlist.liquid): the « Produits » /
 * « Marques suivies » tabs, and the list of brands the customer follows.
 *
 *   1. GET /apps/loyalty/brands (O'Club app proxy, omes_loyality_v2)
 *        -> { authenticated, followed: string[] (oldest first), max, remaining, reward? }
 *   2. one card per handle, drawn by Shopify:
 *        /collections/<handle>?section_id=omes-followed-brand-card
 *
 * Unfollowing is done by assets/omes-brand-follow.js (the cards carry
 * [data-follow][data-brand]); this script listens to its
 * `omes:brand-follow-change` event to dim the card and update the counts.
 * `?vue=marques` opens the brands tab.
 */
(function () {
  "use strict";

  var ENDPOINT = "/apps/loyalty/brands";
  var CARD_SECTION = "omes-followed-brand-card";
  var WISHLIST_KEY = "at_wishlist"; // assets/wishlist.js

  // ── The OMES account's follows ─────────────────────────────────────────────
  // Since 21 Oct 2026 the customer's account on omes.tn is the marketplace's own
  // (sections/mon-compte.liquid; its token sits in localStorage `omes_customer`,
  // the contract with assets/mon-compte.js). When that token is there, the follows
  // are the account's — the marketplace's /account/brands — answered in the same
  // shape as the loyalty proxy; without it, the proxy (a Shopify-signed customer)
  // still answers, and a signed-out click goes to /pages/mon-compte.
  // Mirror of assets/omes-brand-follow.js (which also does the writes).
  var ACCOUNT_API = (window.omesApiBase || "https://partenaires.omes.tn") + "/api/storefront/v1";
  var ACCOUNT_LOGIN = "/pages/mon-compte";
  function accountToken() {
    try {
      var s = JSON.parse(localStorage.getItem("omes_customer") || "null");
      return s && s.token && (!s.expiresAt || Date.parse(s.expiresAt) > Date.now()) ? s.token : null;
    } catch (e) { return null; }
  }
  function accountHeaders(token, json) {
    var h = { Accept: "application/json", "X-Customer-Token": token };
    if (json) h["Content-Type"] = "application/json";
    return h;
  }
  // { authenticated, followed (oldest first, like the proxy), max, remaining, reward }
  function accountFollows(token) {
    return fetch(ACCOUNT_API + "/account/brands", { headers: accountHeaders(token), mode: "cors", credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !Array.isArray(d.brands)) return { authenticated: false, followed: [] };
        var followed = d.brands.map(function (b) { return b.handle; }).reverse();
        return { authenticated: true, followed: followed, max: Number(d.max) || 0, remaining: Math.max(0, (Number(d.max) || 0) - followed.length), reward: Number(d.reward) || 0 };
      });
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  // ── Tabs ────────────────────────────────────────────────────────────────
  function initTabs(box) {
    var tabs = Array.prototype.slice.call(box.querySelectorAll("[data-fav-tab]"));
    if (!tabs.length) return;

    function show(name, updateUrl) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-fav-tab") === name;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute("aria-controls"));
        if (panel) panel.hidden = !on;
      });
      if (!updateUrl || !window.history || !history.replaceState) return;
      var url = new URL(window.location.href);
      if (name === "marques") url.searchParams.set("vue", "marques");
      else url.searchParams.delete("vue");
      history.replaceState(history.state, "", url.pathname + url.search + url.hash);
    }

    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        show(t.getAttribute("data-fav-tab"), true);
      });
      t.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        e.preventDefault();
        var next = tabs[(i + (e.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length];
        next.focus();
        show(next.getAttribute("data-fav-tab"), true);
      });
    });

    var vue = new URLSearchParams(window.location.search).get("vue");
    show(vue === "marques" ? "marques" : "produits", false);
  }

  function productCount(box) {
    var el = box.querySelector("[data-fav-products-count]");
    if (!el) return;
    var n = 0;
    try {
      var list = JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || "[]");
      if (Array.isArray(list)) n = list.length;
    } catch (e) {
      /* private window / blocked storage: no count */
    }
    el.textContent = n > 0 ? String(n) : "";
  }

  // ── Followed brands ─────────────────────────────────────────────────────
  function FollowedBrands(panel, box) {
    this.panel = panel;
    this.box = box;
    this.list = panel.querySelector("[data-fb-list]");
    this.max = 0;
    this.following = {}; // handle -> true while followed
  }

  FollowedBrands.prototype.state = function (name) {
    var states = this.panel.querySelectorAll("[data-fb-state]");
    for (var i = 0; i < states.length; i++) {
      states[i].hidden = states[i].getAttribute("data-fb-state") !== name;
    }
  };

  FollowedBrands.prototype.count = function () {
    var n = 0;
    for (var k in this.following) if (this.following[k]) n++;
    return n;
  };

  FollowedBrands.prototype.summary = function () {
    var n = this.count();
    var countEl = this.panel.querySelector("[data-fb-count]");
    if (countEl) {
      var txt = n + (n > 1 ? " marques suivies" : " marque suivie");
      if (this.max > 0) txt += " sur " + this.max;
      countEl.textContent = txt;
    }
    var badge = this.box.querySelector("[data-fb-badge]");
    if (badge) badge.textContent = n > 0 ? String(n) : "";
  };

  FollowedBrands.prototype.reward = function (points) {
    var el = this.panel.querySelector("[data-fb-reward]");
    if (!el) return;
    if (points > 0) {
      el.textContent = "+" + points + " points O'Club pour chaque nouvelle marque suivie.";
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  };

  FollowedBrands.prototype.load = function () {
    var self = this;
    self.state("loading");
    var token = accountToken();
    (token
      ? accountFollows(token)
      : fetch(ENDPOINT, { credentials: "include", headers: { Accept: "application/json" } }).then(function (r) {
          if (r.status === 401) return { authenticated: false };
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.json();
        }))
      .then(function (data) {
        if (!data || !data.authenticated || !Array.isArray(data.followed)) {
          throw new Error("not authenticated");
        }
        self.max = Number(data.max) || 0;
        self.reward(Number(data.reward) || 0);
        self.following = {};
        var handles = data.followed.slice().reverse(); // most recent first
        handles.forEach(function (h) {
          self.following[h] = true;
        });
        self.summary();
        if (!handles.length) {
          self.state("empty");
          return null;
        }
        return Promise.all(handles.map(fetchCard)).then(function (cards) {
          self.list.textContent = "";
          cards.forEach(function (c) {
            self.list.appendChild(c);
          });
          self.state("list");
        });
      })
      .catch(function (err) {
        console.error("[omes-followed-brands] load failed", err);
        self.state("error");
      });
  };

  FollowedBrands.prototype.onChange = function (detail) {
    if (!detail || !detail.brand || !(detail.brand in this.following)) return;
    this.following[detail.brand] = !!detail.following;
    var cards = this.list.querySelectorAll("[data-fb-card]");
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute("data-brand") === detail.brand) {
        cards[i].classList.toggle("is-unfollowed", !detail.following);
      }
    }
    this.summary();
  };

  function fetchCard(handle) {
    var url =
      root() + "collections/" + encodeURIComponent(handle) + "?section_id=" + CARD_SECTION;
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) {
        return r.ok ? r.text() : "";
      })
      .then(function (html) {
        var tpl = document.createElement("template");
        tpl.innerHTML = html;
        var card = tpl.content.querySelector("[data-fb-card]");
        return card ? document.importNode(card, true) : fallbackCard(handle);
      })
      .catch(function () {
        return fallbackCard(handle);
      });
  }

  // The handle is not (or no longer) a collection: still show it, so the
  // customer can unfollow it and free a slot.
  function fallbackCard(handle) {
    var name = handle.replace(/[-_]+/g, " ").replace(/\b\w/g, function (c) {
      return c.toUpperCase();
    });
    var card = document.createElement("article");
    card.className = "omes-fb-card omes-fb-card--plain";
    card.setAttribute("data-fb-card", "");
    card.setAttribute("data-brand", handle);

    var media = document.createElement("span");
    media.className = "omes-fb-card__media";
    media.setAttribute("aria-hidden", "true");
    var initial = document.createElement("span");
    initial.className = "omes-fb-card__initial";
    initial.textContent = name.charAt(0);
    media.appendChild(initial);

    var body = document.createElement("div");
    body.className = "omes-fb-card__body";
    var h = document.createElement("h3");
    h.className = "omes-fb-card__name";
    h.textContent = name;
    var meta = document.createElement("p");
    meta.className = "omes-fb-card__meta";
    meta.textContent = "Boutique indisponible pour le moment";
    body.appendChild(h);
    body.appendChild(meta);

    var actions = document.createElement("div");
    actions.className = "omes-fb-card__actions";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "omes-fb-card__follow is-following";
    btn.setAttribute("data-follow", "");
    btn.setAttribute("data-brand", handle);
    btn.setAttribute("aria-pressed", "true");
    btn.setAttribute("aria-label", "Suivre " + name);
    btn.setAttribute("data-follow-text", "Suivre");
    btn.setAttribute("data-following", "Suivie");
    var lbl = document.createElement("span");
    lbl.setAttribute("data-follow-label", "");
    lbl.textContent = "Suivie";
    btn.appendChild(lbl);
    actions.appendChild(btn);

    card.appendChild(media);
    card.appendChild(body);
    card.appendChild(actions);
    return card;
  }

  function init() {
    var box = document.querySelector("[data-fav-tabs-root]");
    if (!box) return;
    initTabs(box);
    productCount(box);

    var panel = box.querySelector("[data-fb-panel]");
    if (!panel || !panel.querySelector("[data-fb-list]")) return; // logged out

    var fb = new FollowedBrands(panel, box);
    var retry = panel.querySelector("[data-fb-retry]");
    if (retry) {
      retry.addEventListener("click", function () {
        fb.load();
      });
    }
    document.addEventListener("omes:brand-follow-change", function (e) {
      fb.onChange(e.detail);
    });
    fb.load();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
